import { badgePlpContainerSx } from '@/components/blocks/PLPProductCard/styles/productBadgesPromotions';
import { getProductTagProps } from '@/components/content/ProductDetails/utils';
import { useLocalization } from '@/data/Localization';
import { useSettings } from '@/data/Settings';
import { ProductType } from '@/data/types/Product';
import { Typography } from '@mui/material';
import { memo } from 'react';

export const ProductBadgesPromotions = memo(({ product }: { product: ProductType }) => {
	const productDetailLabels = useLocalization('productDetail');
	const { settings } = useSettings();

	const { labelText, badgePlp } = getProductTagProps(settings.userData, product);

	if (!labelText) return null;

	return (
		<Typography className={`badge_plp ${badgePlp}`} component="span" sx={badgePlpContainerSx}>
			{productDetailLabels[labelText].t()}
		</Typography>
	);
});
